// OfferCard.jsx
import React, { useState } from "react";
import { FileText } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../../../../utility/setUserClickData";
import { useDispatch } from "react-redux";
import { setAAurl, setIframeUrl } from "../../../../store/app/aaSlice";
import { setOffers } from "../../../../store/app/appReducer";
import callApi from "../../../../utility/apiCaller";
import useAddLead from "../../hooks/addLeadtoCRM";
import useUserEvent from "../../../../hooks/setUserclickhook";

const DMI_ID = "68ad8ed5078abf6c677e4303";
const DMI = "DMI";
const FATAKPAY_ID = "6851271c3a9753dd00d85475"
const HERO_ID = "67ef646df80610d286084e60"
const ADITYA_BIRLA_CAPITAL_ID = "662752eb65fdba1a48d6e480"

const OfferCard = ({
  offer,
  isExpanded,
  onExpand,
  key,
  setCurrentStep,
  leadId,
}) => {
  const isDMIOffer = offer?.lender_name === DMI || offer?.lender_id === DMI_ID;
  const isHeroOrFatakPayOffer = offer?.lender_id === FATAKPAY_ID || offer?.lender_id === HERO_ID;
  const isFatkPayOffer = offer?.lender_id === FATAKPAY_ID
  const isAdityaBirlaCapitalOffer = offer?.lender_id === ADITYA_BIRLA_CAPITAL_ID
  const aaReq = offer?.aa_required;
  const dispatch = useDispatch();
  const addLead = useAddLead();

  const [loadingStep, setLoadingStep] = useState(false);
  const { trackUserEvent } = useUserEvent();

  const callAPIandRedirect = async () => {
    if (!leadId) return;

    try {
      // show loader while fetching lead
      setLoadingStep(true);

      const res = await callApi(
        "v1/lead/list",
        "post",
        {
          filters: { _id: leadId },
        },
        "core"
      );

      if (res.status === "Success" && res.data?.leadList.length > 0) {
        const { dmi_offers_details } = res.data.leadList[0];

        dispatch(setOffers(dmi_offers_details));
        setCurrentStep((prev) => prev + 1);
      } else {
        throw new Error("Error while fetching data");
      }
    } catch (error) {
      console.error("Error calling API:", error);
    } finally {
      setLoadingStep(false);
    }
  };

  const [params] = useSearchParams();
  const handleClick = () => {
    trackUserEvent(
      `offer-apply-button-prefr-v2-lead-${offer.lender_name}`,
      offer.lead_id
    );
    trackUserEvent(`offer-apply-button-prefr-v2-lead`, offer.lead_id);

    // setUserClickData({
    //   event_name: `offer-apply-button-for-fb-campaign-${offer.lender_name}`,
    //   user_id: offer.lead_id || "No User ID found",
    //   affiliate_id: params.get("aff_id") || "No Aff_id found",
    //   utm_source: params.get("utm_source") || params.get("utm_medium") || "",
    // });
    // setUserClickData({
    //   event_name: `offer-apply-button-for-fb-campaign`,
    //   user_id: offer.lead_id || "No User ID found",
    //   affiliate_id: params.get("aff_id") || "No Aff_id found",
    //   utm_source: params.get("utm_source") || params.get("utm_medium") || "",
    // });

    // Call useAddLead hook when offer is selected
    if (leadId) {
      try {
        addLead({
          leadId: leadId,
          lead_type: "live",
          priority: 2,
          stage: `Offer Clicked for ${offer.lender_name}`,
        }).catch((error) => {
          console.error("Error adding lead to CRM:", error);
        });
      } catch (error) {
        console.error("Error adding lead to CRM:", error);
      }
    }

    if (isDMIOffer && aaReq) {
      dispatch(setAAurl(offer.app_url));
      setCurrentStep(4);
    } else if (isDMIOffer && !aaReq) {
      callAPIandRedirect();
    }
    else if (isFatkPayOffer) {
      dispatch(setIframeUrl(offer.app_url))
      setCurrentStep(61)
    }
    else if (isAdityaBirlaCapitalOffer) {
      window.location.href = `https://oneapp.abfldirect.com/epl/login?dsa_hash=2ddf40dc7506e40175ed13f475e95d21878481b1ae9e1bca7cb64e6fe550a347&utm_source=digitmoney&utm_medium=sms&utm_campaign=pa&utm_term=${offer.lead_id}`;
    }
    else {
      window.location.href = `${offer.app_url}`;
    }
  };

  const horizontalLogo = offer?.banking_partners_hl || offer?.logo_image_url;

  const verticalLogo = offer?.banking_partners_vl || offer?.logo_image_url;

  return (
    <div
      className={`w-full  rounded-[20px] shadow-md border-[1px] border-[#009477] transition cursor-pointer 
      ${isExpanded ? "p-4 bg-[#aef4e6]" : "py-3 px-4 bg-[#006F59]"} `}
      key={key}
      onClick={onExpand}
    >
      {/* ---------- TOP SECTION ---------- */}
      {isExpanded && (
        <img src={horizontalLogo} alt="lender" className="w-32 mx-auto" />
      )}

      <div className="flex items-center justify-between">
        {/* Collapsed State UI */}
        {!isExpanded && (
          <div className="flex items-center space-x-4">
            <img
              src={verticalLogo}
              className="w-[60px] h-[60px] object-cover"
              alt="logo"
            />

            <div>
              <p className="text-sm text-[#FFFFFF]">
              {["69a2c7ab1f6f4ddfd5577314", "69ea0b864084a68bdadc40bd"].includes(offer.lender_id)
                ? "Gold Loan Amount:"
                : offer.lender_id === "69a1d3801f6f4ddfd55732ed"
                ? "Credit Line Amount:"
                : [
                   "662752eb65fdba1a48d6e466",
                    "666ec1953a9a969d8f9980f1",
                    "67762d497ae263a3ec86347e",
                    "6799b8fada60414f0f195bf9",
                    "67bd3abe694463207380f33d",
                    "67be8fc6049b9a4e3af8191a",
                    "67e23d6fe162ba8f717ec5bf",
                    "67ef646df80610d286084e60",
                    "68401febe871a7a9504dc2e3",
                    "699d44721f6f4ddfd556e5cd",
                    "6954d268fb8b8c1ebb0d1937",
                    "68b7cb3721c19b150d2893da",
                    "662752eb65fdba1a48d6e47c",
                    "69dd0df04d3185176dd02d27",
                  ].includes(offer.lender_id)
                ? "Max Loan Amount:"
                : "Pre-Approved Amount:"}
              </p>
              <p className="text-lg font-semibold text-[#FFFFFF]">
                {offer?.credit_limit.includes("to") ? "" : "upto "} ₹
                {offer?.credit_limit}
              </p>
            </div>
          </div>
        )}

        {/* Expand Arrow */}
        {!isExpanded && (
          <img
            src="/assets/img/Group 240.png"
            className="w-[29px] h-[29px]"
            alt="arrow"
          />
        )}
      </div>

      {/* ---------- EXPANDED STATE ---------- */}
      {isExpanded && (
        <>
          <hr className="my-2" />

          {/* Pre-Approved Amount */}
          <div className="flex gap-2 text-gray-800">
            {/* <span className="font-atkinson">
              {offer?.is_max ? "Max Loan Amount:" : "Pre-Approved Amount:"}
            </span> */}
             <span className="font-atkinson">
              {["69a2c7ab1f6f4ddfd5577314", "69ea0b864084a68bdadc40bd"].includes(offer.lender_id)
                ? "Gold Loan Amount:"
                : offer.lender_id === "69a1d3801f6f4ddfd55732ed"
                ? "Credit Line Amount:"
                : [
                   "662752eb65fdba1a48d6e466",
                    "666ec1953a9a969d8f9980f1",
                    "67762d497ae263a3ec86347e",
                    "6799b8fada60414f0f195bf9",
                    "67bd3abe694463207380f33d",
                    "67be8fc6049b9a4e3af8191a",
                    "67e23d6fe162ba8f717ec5bf",
                    "67ef646df80610d286084e60",
                    "68401febe871a7a9504dc2e3",
                    "699d44721f6f4ddfd556e5cd",
                    "6954d268fb8b8c1ebb0d1937",
                    "68b7cb3721c19b150d2893da",
                    "662752eb65fdba1a48d6e47c",
                    "69dd0df04d3185176dd02d27",
                  ].includes(offer.lender_id)
                ? "Max Loan Amount:"
                : "Pre-Approved Amount:"}
              </span>
            <span className="font-semibold">
              {offer?.credit_limit.includes("to") ? "" : "upto "} ₹
              {offer?.credit_limit}
            </span>
          </div>

          <hr className="my-2" />

          {/* Tenure */}
          {offer.lender_id === "69a2c7ab1f6f4ddfd5577314" ? (
            <p className="text-gray-700">
              Your details have been shared with the IIFL. Someone from IIFL team will
              contact you within the next 24–48 hours.
            </p>
          ) : offer.lender_id === "69ea0b864084a68bdadc40bd" ? (
            <p className="text-gray-700">
              Your details have been shared with the Muthoot Finance. Someone from Muthoot team will
              contact you within the next 24–48 hours.
            </p>
          ) : (
            <p className="text-gray-700">
              Tenure: {offer.tenure || 48} Months
            </p>
          )}

          <hr className="my-2" />

          {/* Interest Rate */}
          {offer?.interest_rate && (
            <>
              <p className="text-gray-700">
                Interest Rate: {offer?.interest_rate}
              </p>
              <hr className="my-2" />
            </>
          )}

          {/* Processing Fees */}
          {offer?.processing_fee && (
            <>
              <p className="text-gray-700">
                Processing Fees: {offer?.processing_fee}
              </p>
              <hr className="my-2" />
            </>
          )}

          {/* Extra Loan Details */}
          <div className="text-sm text-gray-700 space-y-2">
            {offer?.apr && (
              <div className="flex justify-between">
                <span className="font-semibold">APR:</span>
                <span>{offer?.apr}</span>
              </div>
            )}

            {offer?.penal_charges && (
              <div className="flex justify-between">
                <span className="font-semibold">Penal Charges:</span>
                <span>{offer?.penal_charges}</span>
              </div>
            )}

            {offer?.kfs_doc && (
              <div className="flex justify-between items-center ">
                <span className="font-semibold">View KFS:</span>
                <a
                  href={offer?.kfs_doc}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-green-700 hover:underline"
                >
                  <FileText className="w-4 h-4 mr-1" />
                  Document
                </a>
              </div>
            )}
          </div>

          {/* ---------- CTA BUTTON ---------- */}
          <button
            className="mt-4 w-full bg-black text-white py-2.5 rounded-lg flex justify-center items-center gap-2 tracking-wide"
            onClick={(e) => {
              e.stopPropagation();
              handleClick();
            }}
            disabled={loadingStep}
          >
            Get Offer
            <img
              src="/assets/img/Get offer CTA icon.svg"
              alt="arrow"
              className="w-4"
            />
          </button>
        </>
      )}
    </div>
  );
};

export default React.memo(OfferCard);
